import React from 'react';
import { Box } from '@mui/material';
import { grey } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';
import { Description } from './sections/Description';
import { SummaryContainer } from './SummaryContainer';
import { FinanceProgramForm } from '../../../../schema';
import { ConfirmSummaryRenderConfig } from '../../../../types';
import { CriteriaSummaryPart } from './sections/CriteriaSummaryPart';
import { SubmissionSettingsSummaryPart } from './sections/SubmissionSettingsSummaryPart';
import { ProgramDetailsSummaryPart } from './sections/ProgramDetailsSummaryPart';
import { ConfigureStructureSummaryPart } from './sections/ConfigureStructureSummaryPart';
import { InsuranceCoveragePart } from './sections/InsuranceCoveragePart';
import { LenderProfiles } from '@trnsact/trnsact-shared-types/src/generated';

interface Props {
  financeProgramFormValues: FinanceProgramForm['program'];
  isLenderCreditAppSettingVisible?: boolean;
}

export const Confirm = ({ financeProgramFormValues, isLenderCreditAppSettingVisible = false }: Props) => {
  const classes = useStyles();

  const renderConfiguration: ConfirmSummaryRenderConfig[] = [
    {
      label: 'Program Details',
      sectionKey: 'details',
      component: ProgramDetailsSummaryPart,
    },
    {
      label: 'Configure Structure',
      sectionKey: 'structure',
      component: ConfigureStructureSummaryPart,
    },
    {
      label: 'Criteria',
      sectionKey: 'criteria',
      component: CriteriaSummaryPart,
    },
    {
      label: 'Submission Settings',
      sectionKey: 'submissionSettings',
      component: SubmissionSettingsSummaryPart,
    },
    {
      label: 'Insurance Coverage Requirements',
      sectionKey: 'insuranceCoverage',
      component: InsuranceCoveragePart,
    },
  ];

  return (
    <Box className={classes.container}>
      <Description guidelines={financeProgramFormValues.first.guidelines} />

      {renderConfiguration.map(({ label, sectionKey, component: Component }) => (
        <SummaryContainer key={label} label={label} sectionKey={sectionKey}>
          <Component
            financeProgramFormValues={financeProgramFormValues}
            isLenderCreditAppSettingVisible={isLenderCreditAppSettingVisible}
          />
        </SummaryContainer>
      ))}
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    gap: '12px',
    display: 'flex',
    cursor: 'default',
    flexDirection: 'column',

    '& .description': {
      gap: '8px',
      display: 'flex',
      flexDirection: 'column',

      '& .content': {
        padding: '4px',
        borderRadius: '4px',
        border: `2px solid ${grey['A100']}`,
      },
    },
  },
});
